import { render } from "./WarningTriangle.vue?vue&type=template&id=277879b4"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WarningTriangle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "277879b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('277879b4', __exports__)) {
    api.reload('277879b4', __exports__)
  }
  
  module.hot.accept("./WarningTriangle.vue?vue&type=template&id=277879b4", () => {
    api.rerender('277879b4', render)
  })

}


export default __exports__